<div class="token cs_modal">
  <div class="animated fadeIn">
    <span
      class="fa fa-times-circle cs_modal_close"
      (click)="fecharPopup()"
    ></span>
    <div class="token__outline">
      <p class="cs_label outline__text">
        Informe a senha na loja para acumular pontos.
      </p>
      <div class="outline__token">
        <ngx-skeleton-loader
          *ngIf="obtendoToken"
          count="4"
          [theme]="{
            'border-radius': '8px',
            height: '40px',
            width: '32px',
            'margin-left': '8px'
          }"
        ></ngx-skeleton-loader>
        <div class="token__container" *ngIf="!obtendoToken && token">
          <p class="token__numero" *ngFor="let num of token">
            {{ num }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
